import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { FreeDataLevel, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { Model } from '../../model/model';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';

@entity('wizeoo.allkeyme.core.message.FreeDataLevel', 'BU')
export class FreedataLevelVO implements IVo {
  private _source: FreeDataLevel;

  /** Le modèle pour l'accés au parentVO */
  protected _model: Model;


  // utilisation du partial pour instantiation
  constructor(model: Model, pSource?: FreeDataLevel) {
    this._model = model;
    this._source = null;
    if (pSource) {
      this._source = pSource;
    } else {
      this._source = new FreeDataLevel();
      this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
    }
  }

  public set source(src: FreeDataLevel) {
    this._source = src;
  }

  public get source(): FreeDataLevel {
    return this._source;
  }

  public get uid(): string {
    return this._source.uid;
  }
  public set uid(uid: string) {
    this._source.uid = uid;
  }

  /**
   * Flag permettant d'indiquer que le freedata n'as jamais était persisté en base
   */
  public isFake: boolean = false;

  public get id(): number {
    return this._source.id;
  }

  public set id(id: number) {
    this._source.id = id;
  }

  /**  */
  public set businessUnitCode(businessUnitCode: string) {
    this._source.businessUnitCode = businessUnitCode;
  }
  public get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }

  /**  */
  public set code(code: string) {
    this._source.code = code;
  }
  public get code(): string {
    return this._source.code;
  }

  /** Domaine */
  public set domain(domain: string) {
    this._source.domain = domain;
  }
  public get domain(): string {
    return this._source.domain;
  }

  /**  */
  public set freedataCode(freedataCode: string) {
    this._source.freedataCode = freedataCode;
  }
  public get freedataCode(): string {
    return this._source.freedataCode;
  }

  /** Level */
  public set level(level: number | null) {
    this._source.level = level;
  }

  public get level(): number | null {
    return this._source.level;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this._source.label = value;
  }
  public get label(): TranslatedEmb {
    return this._source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this._source.description = value;
  }
  public get description(): TranslatedEmb {
    return this._source.description;
  }

  /**
   * return le label correspondant à la locale si le freedata level a un label, sinon null
   */
  public getEntrieLabel(): string {
    if (this.label && !!this.label?.keys) {
      return this.label.keys[Model.getInstance().localeEngine.getLocale()]
        ? this.label.keys[Model.getInstance().localeEngine.getLocale()].val
        : Object.values(this.label.keys)[0].val;
    }
    return null;
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = Model.getInstance().localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = Model.getInstance().localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  /**
   * Return translated label
   * @return string
   */
  get trsLabel(): string {
    return Model.getInstance().localeEngine.translate(this.label);
  }

  public get trsDescription(): string {
    return Model.getInstance().localeEngine.translate(this.description);
  }

  /** L'élément est-il persisté? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this._source.id > 0;
  }
}
